var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_15429_19810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2596 11.4048H32.1595V10.5048V9.82042C32.1595 8.80625 32.8353 7.90795 33.8057 7.62335L34.4494 7.43457L35.0917 7.62324C36.0627 7.90848 36.7387 8.80601 36.7387 9.82042V13.0183C36.7387 14.1309 36.1711 14.7788 35.4494 15.0799L35.4071 15.0975L35.3669 15.1194C35.1701 15.2261 34.8809 15.311 34.462 15.311H31.1141H30.2141V16.211V19.9423C30.2141 21.242 29.4544 22.3801 28.3486 22.9246L27.3948 23.3943L28.0155 24.2575C28.6401 25.1261 28.9854 25.7706 29.1933 26.5664C29.3675 27.2331 29.4547 28.0414 29.4817 29.2196H28.6191C28.5919 27.9824 28.4931 27.0938 28.2183 26.3103C27.8783 25.3408 27.2888 24.5992 26.497 23.6031L26.2268 23.2631H25.7925H14.8686H14.4343L14.1641 23.6031C13.3727 24.5988 12.7827 25.341 12.4426 26.3102C12.1677 27.0937 12.0687 27.9823 12.0415 29.2196H11.1794C11.2064 28.0415 11.2936 27.2332 11.4678 26.5664C11.6757 25.7704 12.021 25.1259 12.6455 24.2576L13.2665 23.3942L12.3123 22.9245C11.2061 22.38 10.4465 21.2419 10.4465 19.9423V16.211V15.311H9.54648H6.19811C5.77913 15.311 5.4896 15.2261 5.29261 15.1191L5.25228 15.0972L5.20994 15.0795C4.48941 14.7785 3.92188 14.1302 3.92188 13.0183V9.82042C3.92188 8.80601 4.59795 7.90848 5.56895 7.62324L6.21118 7.43457L6.85489 7.62335C7.82552 7.90801 8.50158 8.80648 8.50158 9.82042V10.5053V11.4053H9.4016L31.2596 11.4048ZM23.2773 16.7418C23.2773 15.1143 21.958 13.7953 20.3305 13.7953C18.7031 13.7953 17.3838 15.1143 17.3838 16.7418C17.3838 18.3693 18.7031 19.6883 20.3305 19.6883C21.958 19.6883 23.2773 18.3693 23.2773 16.7418Z",
    stroke: "white",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3.1001H11",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 3.1001H39",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7V1",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 7V1",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15429_19810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneInactive);
export default __webpack_public_path__ + "static/media/droneInactive.24a94badf72345912710feee7c79f6a4.svg";
export { ForwardRef as ReactComponent };